import { render, staticRenderFns } from "./TestingPage.vue?vue&type=template&id=d01603a8&scoped=true&"
import script from "./TestingPage.vue?vue&type=script&lang=js&"
export * from "./TestingPage.vue?vue&type=script&lang=js&"
import style0 from "./TestingPage.vue?vue&type=style&index=0&id=d01603a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01603a8",
  null
  
)

export default component.exports